
import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultAcknowledementOfClientHandbook = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultAcknowledementOfClientHandbook' className='file-pdf-document'>
            <div className='file-template'>



                <p className='w-750'>
                    <b> <center> ACKNOWLEDEMENT OF CLIENT HANDBOOK  </center> </b>
                </p>
                <p className='w-750'>
                    The CLIENT hand book details the Jackson Hands of Change Policy and Procedures.  It is the Agencies responsibility to provide a copy to every client receiving mental health services.  Jackson Hands of Change has explained in person the JHC Client Handbook:
                    <ul>
                        <li>Scope of Services</li>
                        <li>Individual Rights and Responsibilities</li>
                        <li>The process for placing a complaint or filing a grievance.</li>
                        <li>That my health and mental health information is kept confidential according to HIPAA guidance.</li>
                        <li>That the use of tobacco  JHC is prohibited on JHC property.</li>
                        <li>JHC is a weapon free zone, no weapons are allowed on JHC property.</li>
                        <li>No illegal drugs or alcohol are allowed on JHC property.</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <b> I ACKNOWLEDGE RECEIPT OR OFFER OF THE JHC CLIENT HANDBOOK </b>
                    <br />
                    The undersigned acknowledges that he/she has reviewed a copy of the Client Handbook which has been communicated to him/her in a meaningful way. Furthermore, he/she has read and understands this document in its entirety and further certifies that he/she agrees to the terms and provisions stated herein.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b> RECEIPT AND REVIEW OF TREATMENT PLAN </b>
                    <br />
                    I,   <input type='text' id='txtNameTreatmentPlan' name='txtNameTreatmentPlan' className='add-only w-200 custom-add-only' /> have reviewed and received my individualized treatment plan. I acknowledge that the plan was created based on my input, need, etc. By signing below I understand that I can request a change in the plan at any time in addition to clinical staff making any recommendations as seen appropriate to my care.

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}